import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const INTRO_HELP = `
  <div>
    <p><strong>Purpose:</strong> In this section you will gather information about your client's goals and needs, the contexts in which they will be using alternative access, and their past experiences with access AT and technology.
    A strong understanding of these issues is a key part of finding a good alternative access method, and is a cornerstone of 
    AT service delivery models such as <a href="https://atohio.org/sites/default/files/uploads/intro_to_at_assessment_models.pdf" target="_blank">the HAAT model and SETT framework</a>.</p>
  </div>
`

const propTypes = {
  firstName: PropTypes.string,
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function GatherInfoIntroContent(props) {
  const firstName = props.firstName;
  return(
    <>
    <p>This includes {firstName}'s:</p>
    <ul>
      <li>Goals and needs</li>
      <li>Contexts and environments for using alternative access</li>
      <li>Past experiences with access AT and other technology</li>
    </ul>
    <p>We'll walk through these items to create a solid foundation for the eval.</p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoIntro(props) {
  const firstName = props.firstName;
  const pageData = {
    image: "",
    faIcon: "", //fa-user",
    pageSectionClassName: "main-section gather",
    majorHeading: "Gather Background Info",
    title: `Let's gather key background information`,
    subTitle: "",
    learnMore: {linkText: "Learn More about what background info we are gathering and why",
                title: "Gather Background Info",
                content: INTRO_HELP
                },
    nextRoute: "/gather-info/goals", //temp static name for next page
    sidebar: false
  }

  console.log("Rendering GatherInfoIntro");
  
  return(
    <>
    <Body page={pageData} contentComponent={<GatherInfoIntroContent firstName={firstName}/>} />
    </>
  );
}

GatherInfoIntro.propTypes = propTypes;
GatherInfoIntro.defaultProps = defaultProps;

export default GatherInfoIntro;